<template>
  <div>
    <div>Your latest order</div>
    <div class="bg-float-default-low mt-16 h-[300px] p-32">Order</div>
  </div>
</template>
